export default [  
  {
    path: '/notifications',
    props: true,
    name: 'notifications',
    component: () => import('@/views/modules/notifications/notifications'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      breadcrumb: [
        { text: 'Dashboard', to: {name:'dashboard'} },
        { text: 'Notifications' }
      ]
    }
  },
]